export default {
  'dashboardandmonitor.monitor.trading-activity': '活動實時交易情況',
  'dashboardandmonitor.monitor.total-transactions': '今日交易總額',
  'dashboardandmonitor.monitor.sales-target': '銷售目標完成率',
  'dashboardandmonitor.monitor.remaining-time': '活動剩余時間',
  'dashboardandmonitor.monitor.total-transactions-per-second': '每秒交易總額',
  'dashboardandmonitor.monitor.activity-forecast': '活動情況預測',
  'dashboardandmonitor.monitor.efficiency': '券核效率',
  'dashboardandmonitor.monitor.ratio': '跳出率',
  'dashboardandmonitor.monitor.proportion-per-category': '各品類占比',
  'dashboardandmonitor.monitor.fast-food': '中式快餐',
  'dashboardandmonitor.monitor.western-food': '西餐',
  'dashboardandmonitor.monitor.hot-pot': '火鍋',
  'dashboardandmonitor.monitor.waiting-for-implementation': 'Waiting for implementation',
  'dashboardandmonitor.monitor.popular-searches': '熱門搜索',
  'dashboardandmonitor.monitor.resource-surplus': '資源剩余',
  'dashboardandmonitor.monitor.fund-surplus': '補貼資金剩余',
};
